





























































































































































































































































































































































































import { distributorUsrs, orderInput, orderCreate, orderPay } from '@/api/daolv'
import { Component, Vue } from 'vue-property-decorator'
import { GUEST_LIST, HOTEL_INFO, RES_ORDER_INPUT } from '@/api/daolv-api'
import CreateRelation from '@/components/CreateRelation/index.vue'
import HotelSure from './components/HotelSure/index.vue'
import PaySuccess from './components/PaySuccess/index.vue'

interface AGE_LIST {
  label: string
  value: number
}

interface PEOPLE_INFO {
  age: number
  isAdult: boolean
  name: {
    first: string
    last: string
  }
}

@Component({
  name: 'hotelReserve',
  components: {
    CreateRelation,
    HotelSure,
    PaySuccess
  },
  directives: {
    // 禁用input输入指令
    disableInput: {
      bind: function (el: any) {
        el.querySelector('input').setAttribute('readonly', true)
      }
    }
  }
})

export default class hotelReserve extends Vue {
  // this.stepActive = 2
  // this.orderId = '744465001' '745601004' '746409015' '746525001'
  private loading = false
  private stepActive = 1 // 步骤条
  private orderId = '' // 订单id
  private reserveInfo = {} as RES_ORDER_INPUT // 预订信息
  private hotelInfo = {} as HOTEL_INFO // 酒店信息
  private hotelId = '' // 酒店产品id
  private roomName = '' // 房间名称
  private ratePlanID = '' // 计划ID
  private startDay = '' // 入住日期
  private endDay = '' // 离店日期
  private getNight = 0 // 几晚
  private roomNum = 1 // 房间数量
  private adultNum = 2 // 成人数量
  private childNum = 0 // 儿童数量
  private checked = false // 是否勾选
  private descVisible = false // 预订弹窗开关
  private createShow = false // 绑定分销商弹框

  get childAgeList () { // 儿童年龄
    const arr = [] as Array<AGE_LIST>
    for (let i = 1; i <= 17; i++) {
      arr.push({
        label: i + '岁',
        value: i
      })
    }
    return arr
  }

  get adultAgeList () { // 成人年龄
    const arr = [] as Array<AGE_LIST>
    for (let i = 18; i <= 100; i++) {
      arr.push({
        label: i + '岁',
        value: i
      })
    }
    return arr
  }

  private reserveForm = { // 预订表单
    // 入住信息
    guestList: [] as Array<GUEST_LIST>,
    // 联系人信息
    contact: {
      email: '',
      name: {
        first: '',
        last: ''
      },
      phone: '' // 联系人手机
    },
    // 分销商
    inputCustName: '',
    distributor: {} as {
      custName: string
      custId: string
    },
    // 留言
    remark: ''
  }

  // 手机效验
  mobileValidator = (rule: any, value: string, callback: (arg?: Error) => void) => {
    if (!/1[3456789]\d{9}/.test(value) || value.length > 11) {
      callback(new Error('请输入正确的手机号'))
    } else {
      callback()
    }
  }

  // 邮箱效验
  emailValidator = (rule: any, value: string, callback: (arg?: Error) => void) => {
    if (!/^[0-9a-zA-Z]+([.-_]*[0-9a-zA-Z]+)*@([0-9a-zA-Z]+[-_]*[0-9a-zA-Z]+.)+[0-9a-zA-Z]{2,6}$/.test(value)) {
      callback(new Error('请输入正确的邮箱'))
    } else {
      callback()
    }
  }

  // 串货绑定 绑定关系 弹框显示
  clickBind () {
    this.createShow = true
  }

  // 改变步骤条
  changeStep (value) {
    console.log('步骤111---', value)
    // if (this.stepActive === value) return
    if (!this.orderId && value === 2) return // 未下单不允许切换步骤条
    this.stepActive = value
  }

  // 打开地图
  private clickMap = (item) => {
    let latitude = 0
    let longitude = 0
    if (item) {
      latitude = item.latitude || 0
      longitude = item.longitude || 0
    }
    if (latitude && longitude) {
      const url = `http://api.map.baidu.com/geocoder?location=${latitude},${longitude}&coord_type=bd09ll&output=html&src=zowoyoo`
      window.open(url, '_blank')
    }
  }

  // 数量改变
  peopleNumChange (value, index, key) {
    console.log(value, index, key)
    let infoList = this.reserveForm.guestList[index].guestInfo
    const adultLength = infoList.filter(v => v.isAdult).length
    const childLength = infoList.filter(v => !v.isAdult).length
    const info = {
      name: {
        first: '',
        last: ''
      }
    }
    if (key === 'adult') {
      if (value > adultLength) {
        infoList.push({
          ...info,
          age: 18,
          isAdult: true
        })
      } else if (value < adultLength) {
        const delAdultIndex = this.lastIndex(infoList, true)
        infoList.splice(delAdultIndex, 1)
      }
    }
    if (key === 'child') {
      if (value > childLength) {
        infoList.push({
          ...info,
          age: 1,
          isAdult: false
        })
      } else if (value < childLength) {
        const delChildIndex = this.lastIndex(infoList, false)
        infoList.splice(delChildIndex, 1)
      }
    }
    infoList = infoList.sort((a: any, b: any) => b.isAdult - a.isAdult) // 成人儿童排序
  }

  // 取成人||儿童 input最后一个索引来做删除
  lastIndex (arr, isAdult) {
    let index = 0
    for (let i = 1; i < arr.length; i++) {
      if (arr[arr.length - i].isAdult === isAdult) {
        index = arr.length - i
        break
      }
    }
    return index
  }

  // 获取分销商
  getDistributorUsrs (callback) {
    distributorUsrs(this.reserveForm.inputCustName)
      .then(res => {
        callback(res)
      }).catch(err => {
        console.error(err)
      })
  }

  // 输入搜索
  querySearchAsync (queryString, callback) {
    this.reserveForm.inputCustName = queryString
    if (queryString) {
      this.getDistributorUsrs(callback)
    }
  }

  // 选中搜索出来的分销商
  handleSelectCustName (item) {
    this.reserveForm.distributor.custName = item.custName
    this.reserveForm.distributor.custId = item.custId
    // console.log(item, this.reserveForm.distributor)
  }

  // 获取输入订单信息
  getOrderInput () {
    const loading = this.$loading({
      lock: true,
      text: '正在拼命为您加载，请耐心等候...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
      customClass: 'loading-class'
    })
    orderInput({
      hotelId: this.hotelId,
      ratePlanID: this.ratePlanID,
      adultCount: this.adultNum,
      childCount: this.childNum,
      sdate: this.startDay,
      edate: this.endDay,
      roomCount: this.roomNum
    }).then(res => {
      loading.close()
      console.log(res)
      if (res.success) {
        this.reserveInfo = res
        this.hotelInfo = res.hotelInfo
        if (this.reserveInfo.refStatus !== 0) {
          this.createShow = true // 供应商绑定弹窗
          this.$message.error({
            message: '未绑定供应商关系，请先绑定再下单！',
            duration: 3000,
            customClass: 'message-tips'
          })
        }
      } else {
        this.$message.error(res.msg)
        this.$router.go(-1)
      }
    }).catch(err => {
      console.error(err)
    })
  }

  // 提交下单 -- 步骤1
  clickSubmit (formName) {
    console.log('提交', formName, this.reserveForm)
    if (this.reserveInfo.refStatus !== 0) {
      // 后端下单未做处理 让前端来提示用户
      this.createShow = true // 供应商绑定弹窗
      return this.$message.error({
        message: '未绑定供应商关系，请先绑定再下单！',
        duration: 3000,
        customClass: 'message-tips'
      })
    }
    if (this.hotelInfo.orderPolicy.length > 0 && !this.checked) {
      return this.$message.error('请阅读并同意《预订须知》中的内容')
    }

    // 处理去除 控制成人、儿童 输入框的冗余参数 adultNum childNum
    const guestList = this.reserveForm.guestList.map(room => {
      const arr = {
        roomNum: room.roomNum,
        guestInfo: room.guestInfo.map(guest => {
          return {
            age: guest.age,
            isAdult: guest.isAdult,
            name: {
              first: guest.name.first,
              last: guest.name.last
            }
          }
        })
      }
      return arr
    })
    const from = this.$refs[formName] as HTMLFormElement
    from.validate((valid, object) => {
      if (valid) {
        console.log('submit!', valid)
        const data = {
          bedType: String(this.reserveInfo.bedType),
          breakfastType: String(this.reserveInfo.breakfastType),
          cancelPolicyList: this.reserveInfo.cancelPolicyList, // 所有取消规则
          checkInDate: this.startDay,
          checkOutDate: this.endDay,
          hotelID: this.hotelId,
          hotelName: this.reserveInfo.hotelInfo.hotelName,
          numOfRooms: this.roomNum, // 房间总数
          price: String(this.reserveInfo.totalPrice),
          ratePlanID: this.reserveInfo.ratePlanID,
          ratePlanName: this.reserveInfo.ratePlanName,
          roomName: this.reserveInfo.roomInfo.roomName,
          custId: this.reserveForm.distributor.custId, // 分销商id
          remark: this.reserveForm.remark,
          contact: this.reserveForm.contact, // 联系人信息
          guestList // 入住客人信息
        }
        console.log(data, guestList)

        this.$msgbox({
          title: '提示',
          message: '请确认信息填写无误了吗？',
          showCancelButton: true,
          confirmButtonText: '确认',
          cancelButtonText: '再看看',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if ((action as any) === 'confirm') {
              instance.confirmButtonLoading = true
              instance.confirmButtonText = '执行中...'
              setTimeout(() => {
                done()
                setTimeout(() => {
                  instance.confirmButtonLoading = false
                }, 300)
              }, 1000)
            } else {
              done()
            }
          }
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在拼命为您加载，请耐心等候...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            customClass: 'loading-class'
          })
          // 创建订单
          orderCreate(data).then(res => {
            loading.close()
            console.log(res)
            if (res.success) {
              this.orderId = res.data
              this.stepActive = 2
              // this.$message.success(res.data || '已创建订单，请确认信息并完成支付') // res.data = orderId 订单id
              this.$message.success('已创建订单，请确认信息并完成支付')
              this.scrollIntoTop()
            } else {
              this.$message.error(res.msg)
            }
          })
        }).catch(() => {
          console.log('已取消')
        })
      } else {
        console.log('error submit!!', object)
        this.$message({
          type: 'error',
          message: '请认真填写完所有信息！'
        })
        return false
      }
    })
  }

  // 确认支付 -- 步骤2
  clickPay () {
    if (this.hotelInfo.orderPolicy.length > 0 && !this.checked) {
      return this.$message.error('请阅读并同意《预订须知》中的内容')
    }
    console.log('确认支付')
    this.$msgbox({
      title: '提示',
      message: '信息确认无误了吗？',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      beforeClose: (action, instance, done) => {
        if ((action as any) === 'confirm') {
          instance.confirmButtonLoading = true
          instance.confirmButtonText = '执行中...'
          setTimeout(() => {
            done()
            setTimeout(() => {
              instance.confirmButtonLoading = false
            }, 300)
          }, 1000)
        } else {
          done()
        }
      }
    }).then(() => {
      this.loading = true
      this.scrollIntoTop()
      // 支付订单
      orderPay(this.orderId).then(payRes => {
        this.loading = false
        if (payRes.success) {
          this.$message.success(payRes.data || payRes.msg)
          this.stepActive = 3 // 下单支付成功
        } else {
          this.$message.error(payRes.data || payRes.msg)
          const timer = setTimeout(() => {
            clearTimeout(timer)
            // window.location.href = 'http://192.168.88.54:8080/#/business/info'
            // 前往商户中心充值
            window.open(`${window.location.origin}/#/business/info`)
          }, 2000)
        }
      }).catch(err => {
        console.error(err)
      })
    }).catch(() => {
      console.log('已取消')
    })
  }

  // 置顶
  scrollIntoTop () {
    const scrollWrapper: any = this.$refs.scrollWrapper
    scrollWrapper.scrollIntoView()
  }

  // 初始化数据
  initData () {
    // this.stepActive = 1
    const {
      hotelId,
      startDate,
      endDate,
      getNight,
      roomNum,
      adultNum,
      childNum,
      ratePlanID,
      roomName
    } = this.$route.query
    if (hotelId) this.hotelId = String(hotelId)
    if (startDate) this.startDay = String(startDate)
    if (endDate) this.endDay = String(endDate)
    if (getNight) this.getNight = Number(getNight)
    if (roomNum) this.roomNum = Number(roomNum)
    if (adultNum) this.adultNum = Number(adultNum)
    if (childNum) this.childNum = Number(childNum)
    if (ratePlanID) this.ratePlanID = String(ratePlanID)
    if (roomName) this.roomName = String(roomName)
  }

  // 悬浮fixed定位提交订单 盒子
  scrollFn () {
    if (![1, 2].includes(this.stepActive)) return
    const distance: number = document.documentElement.scrollHeight - window.innerHeight - window.pageYOffset
    const bottomBox = document.querySelector('.reserve-submit') as HTMLDivElement
    if (distance <= 188) {
      bottomBox.style.bottom = 188 - distance + 'px'
    } else {
      bottomBox.style.bottom = '0'
    }
  }

  // 获取对应房间数的动态输入框
  getSizeGuestList (length) {
    let roomNum = 0
    const adultArr: Array<PEOPLE_INFO> = [] // 成人数量信息
    const childArr: Array<PEOPLE_INFO> = [] // 儿童数量信息
    for (let j = 0; j < this.adultNum; j++) {
      const adultInfo = {
        age: 18,
        isAdult: true,
        name: {
          first: '',
          last: ''
        }
      }
      adultArr.push(adultInfo)
    }
    for (let j = 0; j < this.childNum; j++) {
      const childInfo = {
        age: 1,
        isAdult: false,
        name: {
          first: '',
          last: ''
        }
      }
      childArr.push(childInfo)
    }
    for (let i = 0; i < length; i++) {
      roomNum++
      const obj = {
        roomNum,
        adultNum: this.adultNum, // 下单需要去除的变量
        childNum: this.childNum, // 下单需要去除的变量
        guestInfo: JSON.parse(JSON.stringify(adultArr.concat(childArr)))
      }
      this.reserveForm.guestList.push(obj)
    }
  }

  mounted () {
    window.addEventListener('scroll', this.scrollFn)
    this.initData()
    this.getOrderInput()
    this.getSizeGuestList(this.roomNum)
  }

  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollFn)
  }
}
